"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CreateHistoryRecordBodySchema = void 0;
const typebox_1 = require("@sinclair/typebox");
const core_1 = require("../../../core");
const ruby_1 = require("../../../ruby");
const common_1 = require("../common");
exports.CreateHistoryRecordBodySchema = (0, core_1.StrictObject)({
    teamId: typebox_1.Type.Optional(core_1.IdSchema),
    userId: typebox_1.Type.Optional(core_1.IdSchema),
    campaignId: typebox_1.Type.Optional(core_1.IdSchema),
    subjectId: (0, core_1.Nullable)(core_1.IdSchema),
    timestamp: core_1.TimestampSchema,
    type: ruby_1.HistoryRecordTypeSchema,
    level: ruby_1.HistoryLevelSchema,
    before: common_1.RecordBeforeSchema,
    after: common_1.RecordAfterSchema,
}, {
    title: "New history record",
    description: "Record relating to a campaign",
});
